import { defineMessages } from 'react-intl'

const scope = `procurify.platform.banking.presenter.FinancialAccountBankingDetailsModal`

export default defineMessages({
  modalHeader: {
    id: `${scope}.modalHeader`,
    defaultMessage: 'Add funds',
  },
  descriptionText: {
    id: `${scope}.descriptionText`,
    defaultMessage:
      'To fund your account, send money from your bank account to your Procurify financial account.',
  },
  accountNameLabel: {
    id: `${scope}.accountNameLabel`,
    defaultMessage: 'Account name',
  },
  accountNumberLabel: {
    id: `${scope}.accountNumberLabel`,
    defaultMessage: 'Account number',
  },
  routingNumberLabel: {
    id: `${scope}.routingNumberLabel`,
    defaultMessage: 'Routing number',
  },
  institutionNumberLabel: {
    id: `${scope}.institutionNumberLabel`,
    defaultMessage: 'Institution number',
  },
  transitNumberLabel: {
    id: `${scope}.transitNumberLabel`,
    defaultMessage: 'Transit number',
  },
  sortCodeLabel: {
    id: `${scope}.sortCodeLabel`,
    defaultMessage: 'Sort code',
  },
  copyButtonLabel: {
    id: `${scope}.copyButtonLabel`,
    defaultMessage: 'Copy {fieldLabel}',
  },
})
